import { Component, PropSync, Vue } from "vue-property-decorator";

@Component<LightBoxOverOneYear>({
  components: {}
})
export default class LightBoxOverOneYear extends Vue {
    // prop in
    @PropSync("info", { type: Object })
    syncedInfo!: {
        show: boolean,
        firstPTag: string,
        secondPTag: string,
        keepButton: string,
        resetButton: string,
    };

    // event out
    private keep() {
        this.$emit("keep"); // 觸發的事件名稱
    }

    private reset() {
        this.$emit("reset"); // 觸發的事件名稱
    }
}